<template>
  <div class="page_container myFooter_wrap">
    <div class="myFooter_content">
      <div class="myleft">
        <div class="logo">
          <img @click="goIndex('/en')"
            src="https://download.hecoos.com/enlightv/2025-17/9afd9fdb8b5717b4b118b43b3c449e13.png" alt="" srcset="" />
        </div>
        <div class="brand">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
            ">
            BRAND
          </p>
          <a href="https://www.enlightv.com">EnlightV</a>
          <a href="https://www.hirender.com">Hirender</a>
        </div>
        <div class="brand">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
            ">
            SOLUTIONS
          </p>
          <router-link to="/en/projection">Projection</router-link>
          <router-link to="/en/lightingDesign">Lighting Design</router-link>
          <router-link to="/en/virtualProduction">xR/VP</router-link>
          <router-link to="/en/renderInteraction">Render Interaction</router-link>

        </div>
        <div class="brand">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
            ">
            PRODUCTS
          </p>
          <router-link to="/en/studio">Studio</router-link>
          <router-link to="/en/hecoosLighting">Lighting</router-link>
          <router-link to="/en/mediaServer">Server</router-link>
          <router-link to="/en/projectorbit">Other Products</router-link>
        </div>
        <div class="myFooter_call">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
            ">
            CONTACT US
          </p>
          <span>Email</span>
          <span>info@enlightv.com</span>
          <!-- <span>Company Direct line</span>
          <span>010-53608556(Monday to Friday 9:00-18:00)</span> -->
        </div>
      </div>

      <div class="myright">
        <div class="login" @click="goIndex('/en/login')">Login</div>
        <div class="register" @click="goIndex('/en/register')">Register</div>
        <div class="icon">
          <div @click="jumpToOrder('https://www.linkedin.com/showcase/hecoos')">
            <i class="iconfont icon-linkedin"></i>
          </div>
          <div @click="jumpToOrder('https://www.facebook.com/hecoos2018')">
            <i class="iconfont icon-facebook"></i>
          </div>
          <div @click="jumpToOrder('https://www.instagram.com/hecoos2018/')">

            <i class="iconfont icon-instagram" style="font-size:30px"></i>
          </div>
          <div @click="jumpToOrder('https://www.youtube.com/@hecoos')">
            <i class="iconfont icon-Youtube-fill"></i>
          </div>
          <!-- <div>
            <img src="https://download.hecoos.com/enlightv/2025-17/8bba227d4c074a01585b4ecfcf979177.png" alt=""
              srcset="" />
          </div>
          <div>
            <img src="https://download.hecoos.com/enlightv/2025-17/9c744bdebcae1c98b950ecedcc1d2248.png" alt=""
              srcset="" />
          </div>
          <div>
            <img src="https://download.hecoos.com/enlightv/2025-17/d464b98e84ae0305ebd71d9f2994f968.png" alt=""
              srcset="" />
          </div> -->

        </div>
      </div>
    </div>
    <div class="tail">
      <div style="
          color: rgba(255, 255, 255, 0.64);
          font-family: '等线 light';
          font-weight: 550;
        ">
        Beijing ICP No. 16030301-3
      </div>
      <div class="rig">
        <div @click="jumpTo('/en/privacyPolicy')" style="font-family: '等线 light'; font-weight: 550; cursor: pointer;">
          Privacy Policy
        </div>
         <div style="margin-left: 60px;">
            <router-link to="/en/llm-info">AI Index</router-link> 
        </div>
        <div @click="jumpTo('/en/serviceAgreement')" style="
            margin-left: 60px;
            font-family: '等线 light';
            font-weight: 550;
            cursor: pointer;
          ">
          Terms of Service
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
export default {
  data() {
    return {};
  },
  methods: {
    goIndex(url) {
      if (url === '/en/login') {
        if (localStorage.getItem("token")) {
          Message.error('You have already logged in and no further login is required.')
          setTimeout(() => {
            this.$router.push("/en/personalCenter");
          }, 1000);
          return
        }
      }
      this.$router.push(url);
    },
    jumpTo(url) {
      this.$router.push(url);
    },
    jumpToOrder(url) {
      window.open(url)
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";

.page_container {
  background-color: #121416;
  padding: 120px 120px 10px 120px;
  // font-family: PingFangSC-Semibold;
  font-family: "roboto" !important;
}




</style>
